<template>
    <div style="height:100%;background:#fff;">
        <div style="height:2.67vw;background:#f6f5fa"></div>
        <div style="padding:0 8vw;font-size:3.73vw">
            <div class="flex_between" style="margin-top:6.67vw">
                <span class="color3">保单号</span>
                <span class="color9">{{policyCode}}</span>
            </div>
            <div class="flex_between" style="margin-top:6.67vw">
                <span class="color3">投保人</span>
                <span class="color9">{{name}}</span>
            </div>
            <div class="flex_between" style="margin-top:6.67vw">
                <span class="color3">预缴金额</span>
                <span class="color9">首缴￥100，单日限额￥10000</span>
            </div>
            <div class="amount-input">
                ￥
                <input
                        type="text"
                        v-model="amount"
                        maxlength="6"
                        style="text-align:left;width: 85%;height: 80%;font-size:8vw"
                        @change="check"
                        @input="changeInputing(amount)"
                        :class="[isWrong?'error':'']"
                />
            </div>

            <div style="margin-top:5.33vw">
                当前余额：
                <span style="color:#3385ff">￥{{balance}}</span>
            </div>
            <div :class="[isWrong?'graybtn':'paybtn']" @click="gonext">去预缴</div>
        </div>
        <!-- <legalHome v-if="showLegal" @closeLegal="closeLegal"></legalHome> -->
    </div>
</template>

<script>
    import {
        showMsg,
        setSessionObj,
        getSessionObj,
        getUrlParams,
        getUserInfo
    } from "../common/utils";
    import {wxPay} from "../common/cashierInApp";
    // import legalHome from '../components/legalHome/legalHome';
    // import { myTrack } from '../common/zhuge';
    export default {
        name: "basicInfo",
        components: {},
        data() {
            return {
                amount: "100",
                isWrong: false,
                balance: "",
                orderId: "",
                name: "",
                policyCode: "",
                from: "",
                showLegal: false
            };
        },
        computed: {},
        watch: {},

        created() {
            // myTrack("进入缴费页");
            //优先使用router的数据
            if (this.$route.params.orderId) {
                let params = this.$route.params;
                this.balance = params.balance;
                this.orderId = params.orderId;
                this.name = params.name;
                this.from = params.from;
                this.policyCode = params.policyCode;
            } else if (getUrlParams().params) {
                let params = JSON.parse(decodeURIComponent(getUrlParams().params));
                this.balance = params.balance;
                this.orderId = params.orderId;
                this.name = params.name;
                this.from = params.from;
                this.policyCode = params.policyCode;
            }
            let transition = document.getElementById("transition");
            if (transition) {
                transition.classList.add('hide');
            }
        },
        methods: {
            check(e) {
                if (
                    isNaN(Number(e.target.value)) ||
                    !Number(e.target.value) ||
                    Number(e.target.value) < 100 ||
                    Number(e.target.value) > 10000 ||
                    Number(e.target.value) % 1 != 0
                ) {
                    this.isWrong = true;
                } else {
                    this.isWrong = false;
                }
            },
            // closeLegal(){
            //   this.showLegal = false;
            // },
            changeInputing(input) {
                this.isWrong = false;
                var input = input + "";
                this.price = input.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
            },
            gonext() {
                if (this.isWrong == false) {
                    this.$loading.show();
                    let url = "/hsbxjj-excellent-driving-insurance/order/orderRechargeApp";
                    var orderId = this.orderId;
                    let params = {
                        mainOrderId: orderId,
                        payMoney: this.amount
                    };
                    let data = encodeURIComponent(JSON.stringify(params));
                    let encodeData = window.$EncryptUtils.compile(data, [{requestContentType: 1}, {userId: 'fa929050330644e68eed7f88a6331eak'}]);
                    this.$http.post(url, encodeData).then(res => {
                        this.$loading.hide();
                        if (res.data.flag) {
                            //下单成功，开始支付
                            let params = {};
                            params.productName = "优驾保续充";
                            params.bxOrderNo = res.data.data.orderId;
                            params.callbackUrl = res.data.data.notifyUrl;
                            params.orderAmount = this.amount;
                            if (navigator.userAgent.indexOf("daka") > -1){
                                params.fcallbackUrl = process.env.VUE_APP_RECHARGECALLBACKURL;
                            }else{
                                params.fcallbackUrl = process.env.VUE_APP_OUTCALLBACKURL;
                            }
                            params.userId = getUserInfo().userId ? getUserInfo().userId : "";
                            params.orderType = "8";
                            setSessionObj("rechargefrom", this.from);
                            if (navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1) {
                                //微信公众号支付
                                params.payChannel = "weiXinPayGzh";
                                params.productCatalog = "822";
                                params.openid = getSessionObj("openId");
                                this.$loading.show();
                                wxPay(params, () => {
                                    this.$loading.hide();
                                });
                            } else {
                                // 大卡以及站外
                                location.href = process.env.VUE_APP_CASHIERURL + "?params=" + encodeURIComponent(JSON.stringify(params)) + "#/cashier";
                            }
                        } else {
                            showMsg(res.data.message);
                        }
                    });
                }
            }
        },
        mounted() {
            if (window.daka && getUrlParams().hp == 1) {
                this.showLegal = false;
            } else {
                this.showLegal = true;
            }
        }
    };
</script>

<style scoped lang="scss">
    .amount-input {
        height: 18.67vw;
        border-bottom: 0.27vw solid #ddd;
        line-height: 18.67vw;
        color: #000;
        font-size: 8vw;
        width: 100%;
        text-align: left;
    }

    .paybtn {
        margin: auto;
        margin-top: 8vw;
        width: 84vw;
        height: 13.33vw;
        background: #3385ff;
        border-radius: 6.67vw;
        line-height: 13.33vw;
        color: #fff;
    }

    .graybtn {
        margin: auto;
        margin-top: 8vw;
        width: 84vw;
        height: 13.33vw;
        background: #ddd;
        border-radius: 6.67vw;
        line-height: 13.33vw;
        color: #fff;
    }

    .error {
        color: red;
    }
</style>